import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { VideoCardProps } from "@routes/Videos/VideosPage/utils/types";

type FeaturedVideoPlaylistCardProps = {
  /** The video to be displayed */
  video: VideoCardProps;
  /** The indicator if the video is active */
  isActive: boolean;
  /** The function to be called when the video is clicked */
  onVideoClick: (video: VideoCardProps) => void;
};

/**
 * This is the component for displaying the featured video playlist card.
 */
const FeaturedVideoPlaylistCard = ({
  isActive,
  video,
  onVideoClick,
}: FeaturedVideoPlaylistCardProps): React.ReactElement => {
  const { title, thumbnail, duration } = video;

  const handleOnClick = () => {
    onVideoClick(video);
  };

  return (
    <div
      data-testid="featured-video-playlist-card-component"
      onClick={handleOnClick}
      className="w-4/10 flex-shrink-0 cursor-pointer lg:w-[20%]"
    >
      <div className="relative">
        <img
          src={thumbnail}
          width={147}
          height={83}
          className="aspect-video w-full"
        />

        {isActive ? (
          <div className="absolute inset-0 flex items-center justify-center bg-black/50">
            <FontAwesomeIcon icon={faPlay} color="#ffffff" size="xs" />
          </div>
        ) : null}
      </div>

      <p className="mb-0 mt-2 block font-poppins text-3xs font-light">
        {duration}
      </p>

      <h3 className="mt-1 font-lct text-base font-bold text-gray-850">
        {title}
      </h3>
    </div>
  );
};

export default FeaturedVideoPlaylistCard;
